import { AnyGoal, CURRENCY } from "@ailenax-overlay/shared";
import { clsx, type ClassValue } from "clsx"
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge"
import { AiOutlineEuro, AiOutlineDollar } from "react-icons/ai";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const msToTimeStr = (ms: number) => {
    const seconds = ms / 1000;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secondsLeft = Math.floor(seconds % 60);

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secondsLeft.toString().padStart(2, "0")}`;
}

export const formatTime = (v: number) => {
  const hours = (Math.trunc(v / 3600)).toString().padStart(2, '0');
  v = v % 3600;

  const minutes = (Math.trunc(v / 60)).toString().padStart(2, '0');
  v = v % 60;

  const seconds = (v % 60).toString().padStart(2, '0');

  let ret = `${minutes}:${seconds}`;
  if (hours !== "00") {
    ret = `${hours}:${ret}`;
  }

  return ret;
}

export const smartFormatTime = (v: number) => {
  const hours = Math.trunc(v / 3600);
  v = v % 3600;

  const minutes = Math.trunc(v / 60);
  v = v % 60;

  const seconds = v % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  } else {
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}

export const secsToHumanDuration = (secs: number) => {
  const hours = Math.trunc(secs / 3600);
  secs = secs % 3600;
  
  const minutes = Math.trunc(secs / 60);
  secs = secs % 60;
  
  const formattedHours = hours.toString();
  const formattedMinutes = minutes.toString();
  const formattedSeconds = secs.toString();
  
  let ret = "";
  if (secs > 0) {
    ret = `${formattedSeconds}s`;
  }
  if (minutes > 0) {
    ret = `${formattedMinutes}m ${ret}`;
  }
  
  if (hours > 0) {
    ret = `${formattedHours}h ${ret}`;
  }
  
  return ret;
}

export const donationFormatter = new Intl.NumberFormat(import.meta.env.VITE_DONATION_LANGUAGE_CODE, { style: "currency", currency: import.meta.env.VITE_DONATION_CURRENCY });

export const defaultFormatters: Record<AnyGoal["kind"], (v: number) => string> = {
    donation: donationFormatter.format,
    bits: (v) => Math.floor(v).toString(),
    subs: (v) => Math.floor(v).toString(),
}

export const donationIcons: Record<CURRENCY, ReactNode> = {
  EUR: <AiOutlineEuro className="inline-block mr-2" />,
  USD: <AiOutlineDollar className="inline-block mr-2" />,
}